import { AnalyticsBrowser } from '@segment/analytics-next';

import { loggingPlugin } from '@/lib/tracking/loggingPlugin';

import { parseJsonSafe } from '../parseJsonSafe';

const NEXT_PUBLIC_ANALYTICS_ENABLED = parseJsonSafe(
    process.env.NEXT_PUBLIC_ANALYTICS_ENABLED,
    false,
);
export const segment = new AnalyticsBrowser();

export const initialiseSegmentAnalytics = () => {
    if (!NEXT_PUBLIC_ANALYTICS_ENABLED) return;
    if (segment.instance) return;

    segment.load(
        {
            writeKey: `${process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}`,
            cdnURL: 'https://io.prezly.com',
            plugins: process.env.NEXT_PUBLIC_SEGMENT_DEBUG ? [loggingPlugin] : [],
        },
        {
            cookie: {
                domain: 'prezly.com',
            },
            integrations: {
                'Segment.io': {
                    apiHost: 'io.prezly.com/v1',
                },
            },
        },
    );
};
